import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent } from '../basic/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private cookiesOpened;

  constructor(
    private matSnackBar: MatSnackBar
  ) { }

  setCookiesOpened(value) {
    this.cookiesOpened = value;
  }

  show(description, type = 'error') { // ok, error, warning
    if (this.cookiesOpened) {
        return;
    }
    this.matSnackBar.openFromComponent(ToastComponent, {
      data: { description, type },
      duration: 3000,
      panelClass: type
    });
  }

  getCookiesOpened() {
    return this.cookiesOpened;
  }
}
